import resumePdf from '../components/Resume.pdf';
import mainImage from './main.png';
import aboutImage from './aboutImage.png';
import medtrackImage from './medtrack.PNG';
import gymImage from "./gym.jpeg";
import posImage from "./suziePOS.PNG";

export const personal = {
  firstName: 'Darryl',
  lastName: 'Brown',
  role: 'Full Stack Developer',
  tagline:
    'Crafting high quality web and mobile experiences—built fast, built right, and built to last.',
  email: 'Anthony.brown.db@gmail.com',
  phone: '+1 (437) 875 - 0371',
  location: 'Toronto, Canada',
  avatar: mainImage,
  aboutImage: aboutImage,
  resumeUrl: resumePdf,
  socials: {
    linkedin: 'https://www.linkedin.com/in/darryl-brown-b-sc-hons-772316186/',
    github: 'https://github.com/French-Thekid',
    twitter: 'https://twitter.com/',
  },
};

export const stats = [
  { value: '8+', label: 'Years Experience' },
  { value: '55+', label: 'Completed Projects' },
  { value: '3+', label: 'Companies Worked' },
];

export const about =
  "Hello world! I'm Darryl Brown, a full stack mobile and web developer with deep, hands on experience across the modern stack. I'm fluent in a wide range of languages, platforms, and embedded systems, and I stay sharp with today's most advanced tools and workflows. I thrive when working independently and I collaborate exceptionally well inside high performing teams.";

export const skillGroups = [
  {
    title: 'Frontend Development',
    subtitle: 'Over 7 years',
    items: [
      { name: 'HTML', level: 100 },
      { name: 'CSS', level: 100 },
      { name: 'JavaScript', level: 100 },
      { name: 'TypeScript', level: 80 },
      { name: 'PHP', level: 70 },
      { name: 'ReactJS', level: 100 },
      { name: 'Flutter', level: 80 },
    ],
  },
  {
    title: 'Backend Development',
    subtitle: 'Over 3 years',
    items: [
      { name: 'Node.js', level: 80 },
      { name: 'AWS', level: 50 },
      { name: 'GraphQL', level: 60 },
      { name: 'REST API', level: 60 },
      { name: 'SQL', level: 70 },
      { name: 'DynamoDB', level: 50 },
      { name: 'Firebase', level: 90 },
    ],
  },
  {
    title: 'UI / UX Design',
    subtitle: 'Over 7 years',
    items: [
      { name: 'Adobe XD', level: 100 },
      { name: 'Figma', level: 80 },
      { name: 'Sketch', level: 90 },
    ],
  },
];

export const services = [
  {
    title: 'UI / UX Design',
    icon: 'Palette',
    description:
      'Human first product design clean visuals, intuitive flows, and interfaces that feel effortless.',
    features: ['Design systems', 'User research & journeys', 'Interactive prototypes', 'Accessibility audits'],
    deliverables: ['Wireframes & user flows', 'High-fidelity mockups', 'Interactive Figma prototype', 'Design system & tokens'],
    timeline: '2 – 4 weeks',
    startingPrice: 'From $2,500',
  },
  {
    title: 'Frontend Development',
    icon: 'Code2',
    description:
      'Pixel perfect, blazing fast interfaces built with React, TypeScript and modern tooling.',
    features: ['React & Next.js', 'TypeScript', 'Responsive & pixel perfect', 'Motion & interactions'],
    deliverables: ['Production React codebase', 'Reusable component library', 'Responsive across all breakpoints', 'Lighthouse 95+ scores'],
    timeline: '3 – 8 weeks',
    startingPrice: 'From $4,000',
  },
  {
    title: 'Backend Development',
    icon: 'Server',
    description:
      'Robust APIs and scalable services—clean architecture, secure auth, and reliable data flows.',
    features: ['Node.js & GraphQL', 'REST APIs', 'SQL & DynamoDB', 'Firebase & AWS'],
    deliverables: ['REST or GraphQL APIs', 'Auth & role based access', 'Database schema & migrations', 'API docs & tests'],
    timeline: '3 – 8 weeks',
    startingPrice: 'From $4,500',
  },
  {
    title: 'Mobile App Development',
    icon: 'Smartphone',
    description:
      'Cross platform apps that feel native delivered end to end from concept to the app stores.',
    features: ['Flutter', 'React Native', 'App Store & Play', 'Native integrations'],
    deliverables: ['iOS & Android builds', 'Push notifications', 'Offline first data sync', 'App Store submission'],
    timeline: '6 – 12 weeks',
    startingPrice: 'From $8,000',
  },
  {
    title: 'Logo & Brand',
    icon: 'Sparkles',
    description:
      'Memorable identities and brand marks that give your product real personality.',
    features: ['Logo systems', 'Type & color', 'Brand guides', 'Iconography'],
    deliverables: ['Primary & secondary logos', 'Color & typography system', 'Brand guidelines PDF', 'Icon set'],
    timeline: '1 – 3 weeks',
    startingPrice: 'From $800',
  },
  {
    title: 'Application Hosting',
    icon: 'Cloud',
    description:
      'Deploy with confidence—managed hosting, CI/CD pipelines and infrastructure done right.',
    features: ['AWS & Firebase', 'CI/CD pipelines', 'Custom domains', 'Monitoring & alerts'],
    deliverables: ['Production deployment', 'CI/CD workflow', 'Custom domain & SSL', 'Monitoring dashboard'],
    timeline: '3 – 7 days',
    startingPrice: 'From $600',
  },
  {
    title: 'Application Maintenance',
    icon: 'Wrench',
    description:
      'Keep your product healthy with proactive updates, bug fixes and performance tuning.',
    features: ['Bug triage', 'Security patches', 'Perf monitoring', 'Feature rollouts'],
    deliverables: ['Monthly maintenance report', 'Security & dependency updates', 'Bug fixes & small features', 'Priority support'],
    timeline: 'Ongoing / monthly',
    startingPrice: 'From $500 / month',
  },
  {
    title: 'Application Revamping',
    icon: 'Wand2',
    description:
      'Give a tired product a fresh soul—modernized UI, refactored code and a real speed boost.',
    features: ['Modern re design', 'Code refactor', 'Perf overhaul', 'Migrations'],
    deliverables: ['UX audit & new design', 'Refactored codebase', 'Performance optimizations', 'Migration plan'],
    timeline: '4 – 10 weeks',
    startingPrice: 'From $5,000',
  },
];

export const projects = [
  {
    title: 'Medical Facility CRM',
    subtitle: 'Medtrack',
    image: medtrackImage,
    tags: ['ReactJS', 'Node.js', 'GraphQL', 'AWS'],
    description:
      'A web platform that transforms how medical institutions run day to day operations—patient records, appointments, and pharmacy workflows all in one place. Patients get a companion mobile app to view records and book visits.',
    role: 'Full Stack Lead',
    year: '2023',
  },
  {
    title: 'E-Commerce Storefront',
    subtitle: "Suzie's POS",
    image: posImage,
    tags: ['Next.js', 'TypeScript', 'Stripe', 'Firebase'],
    description:
      'A high conversion storefront with real time inventory, seamless Stripe checkout, and a lightning fast, image first product browsing experience designed to keep customers engaged and drive more sales.',
    role: 'Frontend & Payments',
    year: '2022',
  },
  {
    title: 'Fitness Tracker App',
    subtitle: 'IronLog',
    image: gymImage,
    tags: ['Flutter', 'Firebase'],
    description:
      'A cross platform fitness companion with live workout tracking, streaks, and personalized coaching insights powered by device sensors.',
    role: 'Mobile Developer',
    year: '2022',
  },
  {
    title: 'Analytics Dashboard',
    subtitle: 'InsightHub',
    image:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80',
    tags: ['ReactJS', 'GraphQL', 'AWS'],
    description:
      'A real time analytics dashboard built for a SaaS team—custom charts, cohort views, and blazing fast queries over millions of rows.',
    role: 'Full Stack Developer',
    year: '2021',
  },
];
